import { SquareRoundCornerIcon } from '../../../../../svg/square-round-corner-icon';
import { LabelWithoutRef } from '../../../../label/label-without-ref';
import { InputNumberWithSteps } from './input-number-with-steps';

const ROUNDED_MIN_SIZE = 0;
const ROUNDED_MAX_SIZE = 96;
const ROUNDED_SIZE_STEPS = [ROUNDED_MIN_SIZE, 16, 32, 48, 64, 80, ROUNDED_MAX_SIZE];

type BorderRadiusProps = {
  value?: number | null;
  onChange?: (value: number | null) => void;
  unit?: 'px' | '%';
};

export function BorderRadius({ value, onChange, unit = 'px' }: BorderRadiusProps) {
  const isPercentage = unit === '%';

  return (
    <div>
      <div className="flex items-center gap-1.5 text-muted-foreground">
        <SquareRoundCornerIcon />
        <LabelWithoutRef className="text-xs font-medium">
          {isPercentage ? 'Redondeo (%)' : 'Redondeo'}
        </LabelWithoutRef>
      </div>
      <InputNumberWithSteps
        ariaLabel={isPercentage ? 'Redondeo (%)' : 'Redondeo'}
        max={isPercentage ? 100 : ROUNDED_MAX_SIZE}
        min={ROUNDED_MIN_SIZE}
        steps={isPercentage ? [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100] : ROUNDED_SIZE_STEPS}
        unit={isPercentage ? '%' : undefined}
        value={value ?? null}
        onChange={onChange}
      />
    </div>
  );
}
